import React, { ReactElement } from "react";
import { ComponentStyleProps } from "../../../lib/styles/props/component-style-props";
import {
  Button,
  ComponentSingleStyleConfig,
  useStyleConfig,
} from "@chakra-ui/react";
import { BiArrowBack } from "react-icons/bi";

export type CMButtonBackProps = {
  icon?: ReactElement;
  labelBack?: string;
  onClick?: () => void;
} & ComponentStyleProps;

/**
 * 前画面に戻るボタンを表示するコンポーネント
 */
export const CMButtonBack = ({
  icon = <BiArrowBack />,
  labelBack,
  onClick,
  sx,
  ...rest
}: CMButtonBackProps) => {
  const styles = useStyleConfig("CMButtonBackStyles");

  return (
    <Button
      onClick={onClick}
      variant={"linkedin"}
      leftIcon={icon}
      sx={{ ...styles, ...sx }}
      {...rest}
    >
      {labelBack}
    </Button>
  );
};

export const CMButtonBackStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    fontWeight: "normal",
    fontSize: "sm",
    color: "gray.500",
    textAlign: "left",
    height: "fit-content",
    width: "fit-content",
    px: "4px",
    py: "4px",
  },
};
